import React from "react";
import cn from "classnames";
import styles from "./Panel.module.sass";
import AccessControl from "../../../../../../../HOC/AccessControl";

const Panel = ({handleCreateRole}) => {

  return (
    <div className={cn("panel", styles.panel)}>
      <div className={styles.info}></div>
      <div className={styles.btns}>
        <AccessControl moduleCode="FvrVqN" requiredPrivilege="cifHqu">
          <button 
            className={cn("button", styles.button)} 
            onClick={handleCreateRole}
          >
            Create Role
          </button>
        </AccessControl>
      </div>
    </div>
  );
};

export default Panel;
